import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreFooter',
  props: {
    footerData: {
      type: Object,
      required: true
    },
    publicDashboardVersion: {
      type: Boolean,
      required: false,
      default: false
    },
    loginPageVersion: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      responsive: false,
      responsiveInput: false
    };
  },
  computed: {
    ...mapState('app', ['language']),
    version() {
      return this.$store.state.app.packageVersion;
    },
    imprintUrl() {
      const lang = this.language || 'de';
      return get(this.footerData, `${lang}.imprintUrl`);
    },
    aboutUsUrl() {
      const lang = this.language || 'de';
      return get(this.footerData, `${lang}.aboutUsUrl`);
    },
    copyrightUrl() {
      const lang = this.language || 'de';
      return get(this.footerData, `${lang}.copyrightUrl`);
    },
    copyrightText() {
      const lang = this.language || 'de';
      return get(this.footerData, `${lang}.copyrightText`);
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    }
  }
};